var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 294,
    viewBox: "0 0 159 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.257 135.9C57.957 135.9 37.857 144.9 32.157 150.3C40.257 124.5 63.657 52.8 81.657 0.299988H65.157C18.057 137.4 8.45703 173.1 6.95703 183C2.75703 192.3 0.357032 203.4 0.357032 214.8C0.357032 258 36.357 293.7 79.257 293.7C122.457 293.7 158.457 258 158.457 214.8C158.457 171.6 122.457 135.9 79.257 135.9ZM79.257 277.8C44.157 277.8 16.257 249.9 16.257 214.8C16.257 179.4 44.157 151.8 79.257 151.8C114.657 151.8 142.557 179.4 142.557 214.8C142.557 249.9 114.657 277.8 79.257 277.8Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber6);
export default __webpack_public_path__ + "static/media/NUMBER_6.ef6e48b68dcfb738fcef7848abd245e3.svg";
export { ForwardRef as ReactComponent };